import { render, staticRenderFns } from "./FreeChickCintillosModal.vue?vue&type=template&id=34e1fb66"
import script from "./FreeChickCintillosModal.vue?vue&type=script&lang=js"
export * from "./FreeChickCintillosModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports